export default "__VITE_ASSET__CQfaNA8f__"